import { render, staticRenderFns } from "./orderAccept.vue?vue&type=template&id=44c50a29&scoped=true"
import script from "./orderAccept.vue?vue&type=script&lang=ts"
export * from "./orderAccept.vue?vue&type=script&lang=ts"
import style0 from "./orderAccept.vue?vue&type=style&index=0&id=44c50a29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c50a29",
  null
  
)

export default component.exports